import {Component, ChangeDetectionStrategy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CommonModule} from '@angular/common';
import {APP_VERSION} from '../../../../environments/config';

@Component({
  selector: 'app-welcome',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.css'
})
export class WelcomeComponent implements OnInit{

  appVersion = APP_VERSION;

  constructor(private router:Router) {
  }

  ngOnInit(): void {
  }

  navigateToRegister() {
    this.router.navigate(['/register']).then(success => {
      if (success) {
       // console.log('Successfully navigated to register');
      } else {
        //console.warn('Failed to navigate to register');
      }
    });
  }

  navigateToLogin() {
    this.router.navigate(['/login']).then(success => {
      if (success) {
       // console.log('Successfully navigated to login');
      } else {
        //console.warn('Failed to navigate to login');
      }
    });
  }

}
